export default __webpack_public_path__ + "static/media/108t.27484981.jpg";